<template>
  <div id="app" class="app">
    <h1 class="title">Put FWA in your Inbox!</h1>
    <b-form-checkbox
      v-for="list in mailingLists"
      :key="list.id"
      v-model="optInListIds"
      :value="list.id"
    >{{ list.title }}</b-form-checkbox>
    <b-input-group class="mt-3">
      <b-form-input
        type="email"
        v-model="email"
        placeholder="E-Mail Address"
      />
      <b-input-group-append>
        <b-button
          v-if="!formIsWorking && !formHasSubscribed && !formHasError"
          variant="primary"
          @click="onClickSubscribe"
        >Sign Me Up!</b-button>
        <b-button
          v-if="formIsWorking"
          variant="secondary"
          disabled
        >
          <b-spinner small variant="light" />
          w
          <b-spinner small variant="light" />
        </b-button>
        <b-button
          v-if="formHasSubscribed"
          variant="success"
          class="btn-kane-green"
          disabled
        >Subscribed!</b-button>
        <b-button
          v-if="!formIsWorking && formHasError"
          variant="danger"
          @click="onClickSubscribe"
        >Retry!</b-button>
      </b-input-group-append>
    </b-input-group>

    <div class="form-error text-danger text-center font-weight-bold mt-1">
      {{ formError }}
    </div>

    <template v-if="isDebug && showCreateKeyBtn">
      <hr>
      <b-button
        variant="danger"
        @click="onClickCreateKey"
        class="w-100"
      >Create Limited Key</b-button>
    </template>
  </div>
</template>

<script>
import isDebug from './debug-flag.js'
import mailingLists from './sendgrid/mailing-lists.js'
import { fwaSubscribe_p } from './sendgrid/api-requests-fwa.js'

export default {
  name: 'fwa-subscribe-vue',
  data () {
    return {
      mailingLists,
      email: undefined,
      formError: undefined,
      formIsWorking: false,
      formHasSubscribed: false,
      formHasError: false,
      isDebug: isDebug,
      optInListIds: mailingLists.map(({id}) => id),
      showCreateKeyBtn: false,
    }
  },
  methods: {
    onClickSubscribe () {
      if ( isDebug ) { console.log(`email: ${this.email}`) }

      // Looks vaguely like an email address?
      if ( !this.email || !this.email.match(/^.+@.+\..+$/) ) {
        this.formError = 'Not an email address'
        this.formHasError = true
        return
      }

      // At least one mailing list selected
      if ( ! this.optInListIds > 0 ) {
        this.formError = 'Check some boxes to continue'
        this.formHasError = true
      }

      this.formHasError = false;
      this.formIsWorking = true;
      fwaSubscribe_p( this.email, this.optInListIds )
        .then(() => {
          this.formHasSubscribed = true
        })
        .catch((error) => {
          console.error(error)
          this.formError = 'Server error in THE CLOUD!'
          this.formHasError = true
        })
        .finally(() => {
          this.formIsWorking = false
        })
    },
    onClickCreateKey () {
      if ( !isDebug ) { return }
      // sendgridCreateLimitedPermissionKey_p('subscribe-only')
      console.log('not implemented')
    }
  }
}
</script>

<style scoped>
  .app {
    width: 350px;
    height: 200px;
  }
  .title {
    font-size: 1.5rem;
    font-weight: bold;
    color: darkslategray;
    font-variant: small-caps;
    margin: 0 0 .5rem 0;
  }
  .btn-kane-green:disabled {
    background-color: #00B285;
  }
</style>
